<div class="saas1 copyright">
    <div class="container">
        <div class="row">
            <div class="col-sm-6">
                <div class="link-horizontal center-text">
                    <ul>
                        <li>
                            <a href="/datenschutz" class="copyright-text op-text">Privacy Policy</a>
                        </li>
                        <li>
                            <a href="/allgemeine-geschaefts-bedingungen" class="copyright-text op-text">Terms &amp; Conditions</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-sm-6">
                <div>
                    <h6 class="copyright-text text-white text-right op-text">Copyright ©2025 Obrecht Studios</h6>
                </div>
            </div>
        </div>
    </div>
</div>
